import React from "react";
import type { Day, DayValue } from "react-modern-calendar-datepicker";
import DatePicker from "../../vendor/react-modern-calendar-datepicker";
import "../../styles/react-modern-calendar-datepicker.css";

export type PersianDay = Day;
export type PersianDayValue = DayValue;

const formatPersianDayValue = (value?: DayValue) => {
  if (!value) return "";

  return [value.year, value.month, value.day].join("/");
};

interface PersianDatePickerProps {
  value?: DayValue;
  onChange: (value: DayValue) => void;
  placeholder?: string;
  name?: string;
  minimumDate?: Day;
  maximumDate?: Day;
  disabledDays?: Day[];
  shouldHighlightWeekends?: boolean;
  disabled?: boolean;
}

export const PersianDatePicker: React.FC<PersianDatePickerProps> = ({
  value,
  onChange,
  placeholder,
  name,
  minimumDate,
  maximumDate,
  disabledDays,
  shouldHighlightWeekends = true,
  disabled = false,
}) => {
  if (disabled) {
    return (
      <input
        readOnly
        disabled
        name={name}
        value={formatPersianDayValue(value)}
        placeholder={placeholder}
        className="omidib-persian-datepicker__input omidib-persian-datepicker__input--disabled"
      />
    );
  }

  return (
    <DatePicker
      value={value}
      onChange={onChange}
      locale="fa"
      inputName={name}
      inputPlaceholder={placeholder}
      minimumDate={minimumDate}
      maximumDate={maximumDate}
      disabledDays={disabledDays}
      shouldHighlightWeekends={shouldHighlightWeekends}
      calendarPopperPosition="bottom"
      wrapperClassName="omidib-persian-datepicker"
      inputClassName="omidib-persian-datepicker__input"
      calendarClassName="omidib-persian-datepicker__calendar"
      colorPrimary="#ad0b06"
      colorPrimaryLight="#f8d9d7"
    />
  );
};
